<template>
  <header
    class="content-header"
    :class="{ 'content-header-scrolled': isScrolled || isScrolledMobile }"
  >
    <div class="content-header-itens">
      <div class="content-menu d-lg-none">
        <a class="content-menu-item btn-menu" @click="setMenuOpen(true)">
          <span></span>
          <p>Menu</p>
        </a>
      </div>
      <div class="content-header-itens-user">
        <div class="content-header-itens-user--letter">
          <p>{{ firstLetterName }}</p>
        </div>
        <div class="content-header-itens-user--name">
          <p>{{ user?.name }}</p>
        </div>
      </div>
      <router-link
        tag="a"
        class="content-menu-configs"
        :to="{ name: 'Manage' }"
      >
        <p>Configurações</p>
        <img
          class="img-fluid"
          src="@/assets/img/image-config.png"
          alt="image config"
          title="image config"
        />
      </router-link>
      <a
        class="content-header-itens-logoff d-none d-lg-flex"
        @click="signOutUser()"
      >
        <p>Sair</p>
        <img
          class="img-fluid"
          src="@/assets/img/icon-logoff.png"
          alt="icon logoff"
          title="icon logoff"
        />
      </a>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      openMenuDesktop: false,
      firstLetterName: null,
    };
  },
  props: {
    isScrolled: Boolean,
    isScrolledMobile: Boolean,
  },
  computed: {
    ...mapGetters({ user: "User/user" }),
  },
  methods: {
    ...mapActions(["toggleFormFixed", "setMenuOpen"]),
    ...mapActions("User", ["signOutUser"]),
    menuDesktopOpen() {
      if (this.openMenuDesktop) {
        this.openMenuDesktop = false;
      } else {
        this.openMenuDesktop = true;
      }
    },
  },
  mounted() {
    if (Object.keys(this.user).length > 0) {
      this.firstLetterName = this.user?.name.split("")[0];
    }
  },
};
</script>

<style lang="scss">
.content-header {
  padding: 20px 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.16);
  &-itens {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    @media (max-width: 991px) {
      justify-content: space-between;
    }
    &-user {
      display: flex;
      align-items: center;
      gap: 15px;
      @media (max-width: 991px) {
        gap: 10px;
      }
      &--name {
        p {
          font-size: 16px;
          font-family: "Font Light Italic";
          color: var(--black);
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 0;
          @media (max-width: 991px) {
            font-size: 14px;
          }
        }
      }
      &--letter {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--yellow);
        border-radius: 100%;
        @media (max-width: 991px) {
          width: 30px;
          height: 30px;
        }
        p {
          font-size: 24px;
          font-family: "Font Semibold Italic";
          color: var(--black);
          margin-bottom: 0;
          @media (max-width: 991px) {
            font-size: 16px;
          }
        }
      }
    }
    &-logoff {
      display: flex;
      align-items: center;
      margin-left: 30px;
      transition: 500ms;
      @media (max-width: 991px) {
        justify-content: center;
        margin-left: 0px;
        margin-top: 30px;
      }
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.8;
      }
      p {
        font-size: 16px;
        font-family: "Font Light";
        color: var(--black);
        text-transform: uppercase;
        margin-right: 10px;
        margin-bottom: 0;
        @media (max-width: 991px) {
          font-family: "Font Semibold";
        }
      }
      img {
        max-width: 32px;
      }
    }
  }
}
.content-menu {
  &-item {
    display: block;
    padding-top: 12px;
    text-decoration: none !important;
    &:hover,
    &:focus {
      cursor: pointer;
    }
    span {
      width: 25px;
      height: 3px;
      background-color: var(--black);
      display: block;
      position: relative;
      transform-origin: center;
      transition: 0.5s ease-in-out;
      margin: 0 auto;
      &::before {
        content: "";
        transition: 0.5s ease-in-out;
        top: -6px;
        display: block;
        background-color: var(--black);
        position: absolute;
        height: 100%;
        width: 100%;
      }
      &::after {
        content: "";
        transition: 0.5s ease-in-out;
        bottom: -6px;
        display: block;
        background-color: var(--black);
        position: absolute;
        height: 100%;
        width: 100%;
      }
    }
    p {
      font-size: 10px;
      color: var(--black);
      font-family: "Font Light";
      margin-bottom: 0px;
      margin-top: 10px;
      text-transform: uppercase;
      text-align: center;
    }
    .active {
      background: 0;
      &::before {
        content: "";
        top: 0 !important;
        transform: rotate(45deg) !important;
      }
      &::after {
        content: "";
        bottom: 0 !important;
        transform: rotate(-45deg) !important;
      }
    }
  }
  &-configs {
    display: flex;
    align-items: center;
    margin-left: 20px;
    transition: 500ms;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
    p {
      font-size: 14px;
      font-family: "Font Light";
      color: var(--black);
      margin-right: 5px;
      margin-bottom: 0;
      @media (max-width: 991px) {
        font-size: 12px;
      }
    }
    img {
      max-width: 20px;
      @media (max-width: 991px) {
        max-width: 15px;
      }
    }
  }
}
.btn-open {
  .icon-arrow-down {
    transform: rotate(180deg);
  }
}
.open-menu {
  margin-top: 0 !important;
}
</style>
